// extracted by mini-css-extract-plugin
module.exports = {"extendedByNone":"ae","table":"af","table--root-table":"ag"};